<template>
	<div class="commission my-3">
		<b-row>
			<b-col cols="12" v-if="!isForeigIncome">
				<el-checkbox v-model="form.epf_excluded" class="mb-4">Exclude EPF</el-checkbox>
			</b-col>
			<b-form @submit.prevent="update">
				<b-col cols="12">
					<b-form-group label="Sales Commission / Incentives / Part Time Job / Pension">
						<b-row>
							<b-col md="4" cols="12" class="d-flex align-items-center my-2" v-for="(commision, index) in commissions"
								:key="index">
								<CurrencyInput v-model="commision.amount"
									:options="currencyOptions"
									:inputPlaceholder="`Month ${index + 1}`" />
							</b-col>
						</b-row>
					</b-form-group>
					<b-button-group class="w-100">
						<b-button @click="addMonths" :disabled="commissions.length >= 12" variant="outline-primary" class="mt-3">+
							Add</b-button>
						<b-button @click="removeMonths" :disabled="commissions.length <= 0" variant="outline-danger" class="mt-3">-
							Remove</b-button>
					</b-button-group>

				</b-col>
				<!-- <b-col cols="4" class="mt-3">
                    <b-button block variant="primary" type="submit">Save</b-button>
                </b-col> -->
			</b-form>
		</b-row>
	</div>
</template>
<script>
import { Button, Checkbox } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	props: ['customer', 'main_form', 'currencyOptions'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[Checkbox.name]: Checkbox,
	},
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	data() {
		return {
			commissions: [],
			form: {
				epf_excluded: this.customer.incomes.main.is_ex_epf_com ?? false
			},
			isCurrencyConverted: false 
		}
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
	},
	watch: {
		customer: {
			handler: function (newValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData(){
			this.commissions = _gHlp.getValue(this.customer,'incomes.commission',[]);
			if(this.isForeigIncome && !this.isCurrencyConverted){
				this.commissions.forEach(el => {
					el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
				});
				this.isCurrencyConverted = true;
			}
		},
		setData() {
			this.isCurrencyConverted = false
			let commissions = this.commissions.map(obj => {
				return {
					...(obj.customer_commision_income_id && { customer_commision_income_id: obj.customer_commision_income_id }),
					// amount: obj.amount
					amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount
				}
			})

			let data = {
				commissions: commissions,
				is_ex_epf_com: this.form.epf_excluded,
			}

			return data;
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.$route.params.customer_id + '/income/commissions', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Commission Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.$route.params.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
			this.isCurrencyConverted = false;
		},
		addMonths() {
			if (this.commissions.length < 12) {
				this.commissions.push({ amount: null });
			}
		},
		removeMonths() {
			if (this.commissions.length > 0) {
				this.commissions.pop();
			}
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>